<template>
  <div style="display: contents">
    <tr>
      <td colspan="4" class="p-0 border-0"></td>
      <td colspan="7" class="p-0 border-0">
        <b-list-group class="my-1">
          <b-list-group-item class="d-flex justify-content-around align-items-center bg-light p-0 mt-n1">
            <span class="p-2 col-2 text-center">
              <span class="text-danger" v-if="booking.status === 'cancelled' "><b>CNX</b></span>
              <template v-else>
                <span class="text-danger" v-if="item.supplier_status === 'not confirmed' "><b>N/A</b></span>
                <span class="text-success" v-if="item.supplier_status === 'confirmed'"><b>CONF</b></span>
                <span class="text-warning" v-if="item.supplier_status === 'requested' || item.supplier_status === 'not requested'"><b>REQ</b></span>
                <span class="text-danger" v-if="item.supplier_status === 'cancelled' "><b>CNX</b></span>
              </template>
            </span>
            <span class="p-2 mx-3 col-8">
              {{ item.short_description }}
            </span>
            <span class="p-2 text-center col-2">
              <b-btn variant="warning" size="sm" v-if="booking.supplier_status == 'confirmed' && documentName"  @click="downloadDocument">
                {{ documentName }}
              </b-btn>
            </span>
          </b-list-group-item>
        </b-list-group>
      </td>
    </tr>
  </div>
</template>

<script>
import { getTravelDocument, downloadPdf } from 'b2b-common/services/api/document'

export default {
  name: 'BookingItemResult',
  props: ['item', 'booking'],
  computed: {
    documentName () {
      if (!this.item.download) return ''
      let documentName = this.$gettext('Voucher')
      if (this.item.is_flight) documentName = this.$gettext('Ticket')
      if (this.item.is_mondial) documentName = this.$gettext('Policy')
      return documentName
    }
  },
  methods: {
    downloadDocument () {
      let type = 'Voucher'
      if (this.item.is_flight) type = 'Ticket'
      if (this.item.is_mondial) type = 'Policy'
      getTravelDocument({ type, item: this.item.id, booking: this.booking.id })
        .then(pdfData => {
          let fileName = this.$pgettext('file name do not use special characters, please use ASCII only', 'voucher')
          if (this.item.is_flight) fileName = this.$pgettext('file name do not use special characters, please use ASCII only', 'ticket')
          if (this.item.is_mondial) fileName = this.$pgettext('file name do not use special characters, please use ASCII only', 'policy')
          fileName += '.pdf'
          downloadPdf({ pdfData, fileName })
        })
    }
  }
}
</script>
